import SequentialEntrance from "./SequentialEntrance.js";

const VueSequentialEntrance = {
  install(Vue, options) {
    Vue.component("sequential-entrance", SequentialEntrance);
  }
};

export default VueSequentialEntrance;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-sequential-entrance/index.js
// module id = null
// module chunks = 